import { render, staticRenderFns } from "./GoogleGranularConsentErrorPage.vue?vue&type=template&id=a7728fde&scoped=true&"
import script from "./GoogleGranularConsentErrorPage.vue?vue&type=script&lang=js&"
export * from "./GoogleGranularConsentErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./GoogleGranularConsentErrorPage.vue?vue&type=style&index=0&id=a7728fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7728fde",
  null
  
)

export default component.exports